import styled from "styled-components/native";
import { pickStyle as _, pickThemeKey as theme } from "utils";
import {
  ContainerWidth,
  ContainerSpace,
  GenderButtonWidth,
  GenderButtonHeight,
} from "./variables";

export const Container = styled.View`
  flex-direction: row;
  justify-content: ${_(ContainerSpace) || "space-between"};
  width: ${_(ContainerWidth) || " 100%"};
  margin: 0 auto;
`;

export const StyledTouchableOpacity = styled.TouchableOpacity`
  border-radius: 5px;
  align-items: center;
  justify-content: center;
  padding: 14px 0;
  width: ${_(GenderButtonWidth) || 134}px;
  height: ${_(GenderButtonHeight) || 115}px;
  background-color: ${props =>
    !props.$isSelected
      ? theme("themeWhite")(props)
      : props.$gender === "F"
      ? theme("themePink")(props)
      : theme("themeLightBlue")(props)};
`;

export const GenderImage = styled.Image`
  width: 100%;
  resize-mode: contain;
  height: 60px;
  margin-bottom: 8px;
`;

export const GenderText = styled.Text`
  font-size: 15px;
  color: ${props =>
    props.$isSelected
      ? theme("themeWhite")(props)
      : theme("themeDarkGrey")(props)};
`;
